export default __webpack_public_path__ + "static/media/info.957e2599.svg";